import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import useLayout from '@context/layout/useLayout';

import { bool } from 'prop-types';
import { styMainPanel, styPanelContent } from './style';

const MainPanel = ({ withBottomPanel }) => {
  const { rightPanel, bottomPanel, tradePanel } = useLayout();

  const styProps = {
    isRightPanelVisible: rightPanel.isVisible,
    isTradePanelVisible: tradePanel.isVisible,
    isBottomPanelNormal: bottomPanel.isNormal,
    isBottomPanelCollapsed: bottomPanel.isCollapsed,
    isBottomPanelExpand: bottomPanel.isExpand,
    withBottomPanel,
  };
  return (
    <div className={styMainPanel(styProps)}>
      <div className={styPanelContent}>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
};

MainPanel.propTypes = {
  withBottomPanel: bool,
};

MainPanel.defaultProps = {
  withBottomPanel: true,
};

export default MainPanel;
